module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7KTKr"))).then(() => parcelRequire('9Lwss'));